import { commentsData } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-chat-3-line"></i>
              用户评价
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              吃瓜群众热评
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              来看看广大吃瓜用户对51吃瓜网的真实评价
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {commentsData.map((comment) => (
              <div
                key={comment.id}
                className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={`51吃瓜网用户 - ${comment.nickname}`}
                      className="w-full h-full object-cover"
                      width="100"
                      height="100"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">
                      {comment.nickname}
                    </div>
                    <div className="text-[10px] text-foreground-400">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line text-primary-500"></i>
                  <span>{comment.likes.toLocaleString()} 赞</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}